<template>
  <div class="flex-1">
    <div class="pannel-1">
      <div class="top-wrapper">
        <div>
          <div class="title">Operational Projects</div>
          <button class="btn primary c-p" @click="refresh">Refresh</button>
        </div>
        <div class="item-wrapper">
          <div class="item">
            <div class="item-title">Total Client Billings</div>
            <div class="item-content">
              {{ totalClientBilling | currencyFilter("$", 2) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">Total Tech Cost</div>
            <div class="item-content">
              {{ totalTechCost | currencyFilter("$", 2) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">Total Profits</div>
            <div class="item-content">
              {{ totalProfits | currencyFilter("$", 2) }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <ag-grid-vue
          style="width: 100%; height: 256px"
          class="ag-theme-material"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          @column-resized="onColumnResized"
          @first-data-rendered="onFirstDataRendered"
          @grid-size-changed="onFirstDataRendered"
          :rowData="rowData"
        ></ag-grid-vue>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import GridDropdownMenu from "./GridDropdownMenu";
import GridCompany from "./GridCompany.vue";
import GridProject from "./GridProject.vue";
import GridTech from "./GridTech.vue";
import { httpGet } from "@/http/http";

export default {
  props: ["propsData"],
  components: {
    AgGridVue,
    GridDropdownMenu,
    GridCompany,
    GridProject,
    GridTech,
  },
  data() {
    return {
      gridOptions: {},
      columnDefs: null,
      rowData: null,

      projects: null,
      companies: null,

      dd: {
        index: null,
        el: null,
        isOpen: false,
      },

      totalClientBilling: 0,
      totalTechCost: 0,
      totalProfits: 0,
    };
  },
  watch: {
    propsData() {
      this.initData();
    },
  },
  beforeMount() {
    this.createColumnDefs();
    this.initData();
  },
  created: function () {
    this.$EventBus.$on("globalClick", (event) => {
      this.hideAgDropdown(event);
    });
    setTimeout(() => {
      this.enableSetLocal = true;
    }, 3000);
  },
  beforeDestroy() {
    this.$EventBus.$off("globalClick");
  },
  methods: {
    openCurrentAgDropdown: function (item, el) {
      if (this.dd.isOpen) {
        this.$set(this.rowData[this.dd.index], "ddOpen", false);
      }
      this.dd.isOpen = item.ddOpen;
      this.dd.index = item.index;
      this.dd.el = el;
    },
    hideAgDropdown: function (e) {
      if (this.dd.el && !this.dd.el.contains(e.target)) {
        this.hideCurrentAgDropdown();
      }
    },
    hideCurrentAgDropdown: function () {
      this.$set(this.rowData[this.dd.index], "ddOpen", false);
      this.dd.isOpen = false;
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    createColumnDefs() {
      this.gridOptions = {
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        sideBar: false,
        enableCellTextSelection: true,
        pagination: true,
        paginationPageSize: 9,
        paginationNumberFormatter: function (params) {
          return "[" + params.value.toLocaleString() + "]";
        },
      };
      this.columnDefs = [
        {
          headerName: "Comapny",
          field: "company_name",
          cellRendererFramework: "GridCompany",
        },
        {
          headerName: "Project",
          field: "project_title",
          cellRendererFramework: "GridProject",
        },
        {
          headerName: "Client Billing",
          field: "clientBilling",
        },
        { headerName: "Tech Cost", field: "techCost" },
        {
          headerName: "Tech Assigned",
          field: "tech_name",
          cellRendererFramework: "GridTech",
        },
        { headerName: "Hours", field: "hours" },
        {
          headerName: "",
          field: "actions",
          width: 180,
          cellClass: "overflow-visible",
          cellRendererFramework: "GridDropdownMenu",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
    },
    initData() {
      if (this.propsData) {
        this.totalClientBilling = 0;
        this.totalTechCost = 0;
        this.totalProfits = 0;
        const values = Object.values(this.propsData);
        const data = (values || []).map((item, index) => {
          const clientBilling = item.hours * item.company_rate || 0;
          const techCost = item.hours * item.tech_rate || 0;
          const profts = clientBilling - techCost;
          this.totalClientBilling += clientBilling;
          this.totalTechCost += techCost;
          this.totalProfits += profts;
          return {
            ...item,
            clientBilling: clientBilling.toFixed(2),
            techCost: techCost.toFixed(2),
            hours: item.hours.toFixed(2),
            profts,
            index,
            ddOpen: false,
          };
        });
        this.rowData = data;
      }
    },
    refresh() {
      httpGet("refresh_overview_projects").then((result) => {
        if (result.ok) {
          this.$toasted.global.toast_success({
            message: "fresh success",
          });
        } else {
          this.$toasted.global.toast_error({ message: "fresh error" });
        }
      });
    },
    onCreateInvoice(compnayId, projectId) {
      this.$emit("onCreateInvoice", compnayId, projectId);
    },
  },
};
</script>

<style scoped>
.top-wrapper {
  padding: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.title {
  font-family: "inter-regular";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #1c1c1c;
}
.item-wrapper {
  display: flex;
}
.item:not(:first-child) {
  margin-left: 40px;
}
.item-title {
  font-family: "inter-regular";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1c1c1c;
}
.item-content {
  font-family: "inter-regular";
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  color: #1c1c1c;
  margin-top: 12px;
}
.btn-wrapper {
  margin-top: 4px;
  display: flex;
}
.btn-wrapper > :not(:first-child) {
  margin-left: 12px;
}
</style>
